export interface AppConfig {
  OIDC_URL: string;
  API_URL: string;
  FEED_URL: string;
  APP_ENV: string;
}

let config: AppConfig | undefined;

export async function loadConfig(): Promise<AppConfig> {
  if (!config) {
    const response = await fetch('/assets/config.json', {
      credentials: 'omit',
      // Don't include any Authorization header
    });

    if (!response.ok) {
      throw new Error(`Failed to load config.json: ${response.status} ${response.statusText}`);
    }

    config = (await response.json()) as AppConfig;
  }

  return config;
}
